<template>
    <div class="flex bg-white items-center shadow-sm p-6 rounded">
        <p class="font-normal m-0 px-4 text-sm text-center" v-html="text"></p>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true,
        },
    },
};
</script>
